<div class="main-content">
  <app-loader></app-loader>
  <p-toast [autoZIndex]="true" class="toast" sticky="true"></p-toast>
  <ng-container *ngIf="isRenderApplication">
    <router-outlet></router-outlet>
  </ng-container>
</div>

